<template>
    <div class="content">
        <div class="card my-1">
            <div class="collapse show"
                 aria-labelledby="headingTwo"
                 data-parent="#accordionResult">
                <div class="card-body">
                    <div class="bs-component"></div>
                    <div class="col-lg-12 d-flex flex-row">
                        <h5><span class="text-primary">流程执行记录</span></h5>
                        <b-spinner small v-show="!hasInit" class="ml-2"></b-spinner>
                        <div class="ml-auto d-flex flex-row"
                             v-if="config.viewInfos">
                            <template
                                v-for="(item,index) of config.viewInfos">
                                <overlay-mini-table class="ml-1"
                                                    :key="index"
                                                    :entity-name="item.entityName"
                                                    :id="item.id"
                                                    :title="item.title"
                                                    :query-api="item.queryApi"
                                                    :data="item.data"
                                                    :fields="item.fields"
                                                    :table-config="item.tableConfig">
                                </overlay-mini-table>
                            </template>
                        </div>
                    </div>
                </div>
            </div>

            <el-timeline class="pr-2" v-if="hasInit">
                <template v-for="item of items">
                    <el-timeline-item :key="item.id"
                                      :timestamp="item.endTime ?
                                      item.endTime+' '+ item.assigneeName +' 用时：'+ item.duration :
                                      item.assigneeName ?
                                      '当前任务处理人：' + item.assigneeName :
                                      '任务未被领取，指派给：'+ item.candidateNames"
                                      placement="top">
                        <el-card>
                            <div class="d-flex flex-row">
                                <h5>{{ item.name }}</h5>
                            </div>
                            <template v-if="item.endTime !== undefined">
                                <div class="d-flex flex-wrap">
                                    <template
                                        v-for="(row,index) of getTaskConfigOfExist(item['taskDefinitionKey'], configure).variables">
                                        <template v-if="checkVariableShow(item.id,row)">
                                            <mini-table v-if="row.type===VALUE_TYPE.TABLE"
                                                        :key="index"
                                                        read-only
                                                        class="col-12"
                                                        :header-title="row.label"
                                                        :items="item.taskLocalVariables[row.name]"
                                                        :fields="cancelTableFieldEdit(row.fields)"
                                                        :need-model-fields="row.needModelFields"
                                                        :entity-name="row.entityName"
                                                        :custom-vuex-name="row.customVuexName"
                                                        :filter-holder="row.filterHolder">
                                            </mini-table>
                                            <KeyValueCell v-else-if="row.saveTo === SAVE_TO.APPROVE"
                                                          :key="index"
                                                          horizontal
                                                          class="col-4 value-cover"
                                                          :value="getApproveText(row.options, getApproveMayOldVersion(item.taskLocalVariables, row.name))">
                                                {{ row.label }}
                                            </KeyValueCell>
                                            <KeyValueCell v-else
                                                          :key="index"
                                                          horizontal
                                                          class="col-4 value-cover"
                                                          :value="getTextOfValueIfIndeed(row,item)">{{ row.label }}
                                            </KeyValueCell>
                                        </template>
                                    </template>
                                    <KeyValueCell key="-1"
                                                  v-if="item.commentList !== undefined && item.commentList.length > 0"
                                                  horizontal
                                                  class="col-4 value-cover"
                                                  :value="item.commentList[0].fullMessage"
                                                  :title="item.commentList[0].fullMessage"
                                                  data-toggle="tooltip">
                                        {{ commentConfig.label }}
                                    </KeyValueCell>
                                </div>
                                <div v-if="item.attachmentIds!==undefined && item.attachmentIds!==''">
                                    <h6>附件：</h6>
                                    <em-attachment getItemsBySelf :attachmentIds="item.attachmentIds"></em-attachment>
                                </div>
                            </template>
                            <div v-else-if="item.assigneeName" style="color: #878787">
                                Processing...
                            </div>
                        </el-card>
                    </el-timeline-item>
                </template>
            </el-timeline>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import KeyValueCell from "@/views/sithMes/prd/PrdOperationExcute/cells/KeyValueCell";
import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
import EmAttachment from "@/components/em/EmAttachment";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
import OverlayMiniTable from "@/components/workflow/stuffs/OverlayMiniTable";

export default {
    name: "WorkflowProcessLine",
    components: {MiniTable, KeyValueCell, EmAttachment, OverlayMiniTable},
    mixins: [emWorkflowTaskMixin, workflowTaskMixins],
    props: {
        processDefinitionKey: String,
        businessKey: Number,
        config: Object,
    },
    data() {
        return {
            items: [],
            hasInit: false,
            viewAttachment: [],
            loading: false,
            configure: {},
            tags: {}
        }
    },
    computed: {
        ...mapState({
            processExecutionDoGet: state => state.workflow.processExecutionDoGet,
        })
    },
    watch: {
        processExecutionDoGet(val, old) {
            if (val && !old) {
                this.initData();
                this.$store.commit('workflow/setProcessExecutionDoGet', false);
            }
        }
    },
    mounted() {
        // this.initData();
    },
    methods: {
        ...mapActions(
            {
                apiPost: "api/post"
            }
        ),
        initConfigBatch() {
            let temp = {}
            for (let id in this.initializedConfig) {
                let configElement = this.initializedConfig[id];
                if (typeof configElement === 'object') {
                    temp[id] = this.initConfig(configElement);
                } else {
                    temp[id] = configElement;
                }
            }
            this.configure = temp;
        },
        initTags() {
            let tagsTemp = {};
            for (let item of this.items) {
                let tagTemp = {};
                let taskConfig = this.getTaskConfigOfExist(item['taskDefinitionKey'], this.configure);
                if (taskConfig.tag !== undefined) {
                    if (taskConfig.hasOwnProperty('changeTag')) {
                        let tag = taskConfig.changeTag(this.$_emWorkflowTaskMixin_businessData, item.taskLocalVariables.approved);
                        this.handleTag(tagTemp, tag);
                    }
                    for (let variable of taskConfig.variables) {
                        if (variable.hasOwnProperty('changeTag')) {
                            let tag = variable.changeTag(item.taskLocalVariables[variable.name]);
                            this.handleTag(tagTemp, tag);
                        }
                    }
                    tagsTemp[item.id] = tagTemp;
                }
            }
            this.tags = tagsTemp;
        },
        handleTag(source, tags) {
            if (tags instanceof Array) {
                for (let pair of tags) {
                    source[pair.name] = pair.value;
                }
            } else {
                source[tags.name] = tags.value;
            }
        },
        initData() {
            if (this.loading) {
                return;
            }
            this.loading = true;
            this.apiPost({
                url: process.env.VUE_APP_EM_WORKFLOW_URL + "/getProcessExecution",
                data: {
                    processDefinitionKey: this.processDefinitionKey,
                    businessKey: this.businessKey
                }
            }).then(response => {
                console.log(response.data)
                let taskHistoricList = response.data['taskHistoricList'];
                if (taskHistoricList && taskHistoricList.length > 0) {
                    this.items = taskHistoricList
                    this.$emit('gotItems', taskHistoricList);
                }
                this.initConfigBatch();
                this.initTags();
                this.hasInit = true
                this.loading = false;
            })
        },
        getApproveText(options, approved) {
            for (let item of options) {
                if (item.value === approved) {
                    return item.text;
                }
                if (item.options !== undefined) {
                    let approveText = this.getApproveText(item.options, approved);
                    if (approveText !== "") {
                        return item.label + "->" + approveText;
                    }
                }
            }
            return "";
        },
        getTextOfValueIfIndeed(row, item) {
            if (row.type === this.VALUE_TYPE.SELECT) {
                for (let option of row.options) {
                    if (option.value === item.taskLocalVariables[row.name]) {
                        return option.text;
                    }
                }
            }
            return item.taskLocalVariables[row.name];
        },
        getApproveMayOldVersion(localValues, newName) {
            if (localValues.hasOwnProperty(newName)) {
                return localValues[newName];
            } else return localValues.approved;
        },
        checkVariableShow(itemId, variable) {
            if (variable.needTag) {
                return this.tags[itemId][variable.needTag] === true;
            }
            return true;
        },
        cancelTableFieldEdit(fields) {
            let temp = JSON.parse(JSON.stringify(fields));
            for (let field of temp) {
                if (field.isInput) {
                    field.isInput = false;
                }
            }
            return temp;
        },
    },
}
</script>

<style scoped>
.value-cover {
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
